import Fetch from 'components/Fetch';

const token = () => 'Bearer ' + localStorage.getItem('token');
export default {
  create: async values => {
    return await Fetch({
      route: '/users',
      method: 'POST',
      token: token(),
      body: JSON.stringify(values)
    });
  },
  list: async (params, signal) => {
    const route = generateUrl(params, '/users');
    return await Fetch({ signal, route, token: token(), method: 'GET' });
  },
  detail: async id => {
    return await Fetch({ route: '/users/' + id, method: 'GET', token: token() });
  },
  self: async signal => {
    return await Fetch({ signal, route: '/company/profile', method: 'GET', token: token() });
  },
  profileUpdate: async values => {
    return await Fetch({
      route: '/profile-update',
      method: 'PUT',
      token: token(),
      body: JSON.stringify(values)
    });
  },
  pictureUpdate: async photo => {
    const fd = new FormData();
    fd.append("photo", photo)
    return await Fetch({
      route: '/user-picture',
      method: 'POST',
      contentType: false,
      token: token(),
      body: fd
    });
  },
  update: async values => {
    return await Fetch({
      route: '/users/' + values.id,
      method: 'PUT',
      token: token(),
      body: JSON.stringify(values)
    });
  },
  active: async id => {
    return await Fetch({
      route: '/users/' + id,
      method: 'PATCH',
      token: token()
    });
  },
  updatePassword: async ({ password: old_password, newPassword: new_password }) => {
    return await Fetch({
      route: '/change-password',
      method: 'PUT',
      token: token(),
      body: JSON.stringify({ old_password, new_password })
    });
  }
};

function generateUrl(params, baseUrl) {
  const ret = [];
  for (let key in params) {
    if (params[key] !== '') {
      ret.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
    }
  }
  const paramString = ret.join('&');
  return paramString ? baseUrl + '?' + paramString : baseUrl;
}
